import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { cn } from '../../../lib/utils';

export function FAQ({ t }: { t: any }) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = t.faq.items;

  return (
    <section id="faq" className="bg-zinc-950 py-24">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-4xl divide-y divide-white/10">
          <h2 className="text-2xl font-bold leading-10 tracking-tight text-white mb-10">{t.faq.title}</h2>
          <dl className="mt-10 space-y-6 divide-y divide-white/10">
            {faqs.map((faq: any, idx: number) => (
              <div key={idx} className="pt-6">
                <dt>
                  <button
                    onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
                    className="flex w-full items-start justify-between text-left text-white"
                  >
                    <span className="text-base font-semibold leading-7">{faq.q}</span>
                    <span className="ml-6 flex h-7 items-center">
                      <ChevronDown
                        className={cn(
                          "h-6 w-6 transform transition-transform duration-200",
                          openIndex === idx ? "rotate-180" : "rotate-0"
                        )}
                        aria-hidden="true"
                      />
                    </span>
                  </button>
                </dt>
                <AnimatePresence>
                  {openIndex === idx && (
                    <motion.dd
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      className="mt-2 pr-12 overflow-hidden"
                    >
                      <p className="text-base leading-7 text-zinc-400 pb-4">{faq.a}</p>
                    </motion.dd>
                  )}
                </AnimatePresence>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
}
